import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { jury } from '../mockData';
import { Card, CardContent } from '../components/ui/card';

const Jury = () => {
  const { language } = useLanguage();
  const t = jury[language];

  return (
    <div className="min-h-screen bg-page py-32">
      <div className="container mx-auto px-8">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-20 animate-fade-in">
          <h1 className="heading-1 text-gold mb-6">{t.title}</h1>
          <p className="body-large text-white/90">{t.subtitle}</p>
        </div>

        {/* Jury Members */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {t.members.map((member, index) => (
            <Card
              key={member.id}
              className="overflow-hidden bg-card-dark border-gold/20 hover:border-gold/50 transition-all duration-300 hover:transform hover:scale-105 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                />
              </div>
              <CardContent className="p-6">
                <h3 className="heading-5 text-gold mb-2">{member.name}</h3>
                <p className="caption text-gray-400 mb-3">{member.title}</p>
                <p className="body-small text-gray-300">{member.bio}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Jury;